<template>
  <el-dialog title="选择要退料的单据" :visible.sync="selectVisible" width="1200px" :show-close="true" class="text-center" :before-close="onClose" append-to-body>
    <div class="content flex-column plr-20 bg-f3f4f7 ptb-10">
      <div class="flex h-30 align-center mb-10">
        <div class="bg-ff flex flex-1 h-30 align-center plr-10 border-ra">
          <div class="flex align-center mr-20 cursor">
            <div class="mr-5 decoration-line"></div>
            <div class="font-bold font-16-46b8b0">{{title}}</div>
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class=" font-12-85" type="text" placeholder="请输入单据号" v-model="inputValue" clearable @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-46b8b0" @click="searchBtn">搜索</button>
        </div>
      </div>
      <div class="flex-1 mb-10">
        <erp-table ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData" @on-select="onSelect"></erp-table>
      </div>
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
    </div>
    <select-return-material ref="selectReturnMaterial" :selectItem="selectItem" :orderDefine="orderDefine"></select-return-material>
  </el-dialog>
</template>

<script>
import ErpTable from '@/components/ErpTable'
import SelectReturnMaterial from './SelectReturnMaterial'
import Pagination from '@/components/Pagination'
export default {
  name: 'SelectReturnMaterialReceipt',
  props: ['title', 'orderDefine'],
  components: {ErpTable, SelectReturnMaterial, Pagination},
  data () {
    return {
      selectVisible: false,
      loading: false,
      inputValue: '',
      page: 1,
      limit: 25,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 100, // 总条数
      tableData: [],
      columnData: [{
        field: 'operate',
        title: '操作',
        width: '70',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '选择',
          methodName: 'on-select',
          type: 'btn'
        }]
      }, {
        field: 'code',
        title: '单据号',
        width: '120'
      }, {
        field: 'status',
        title: '单据状态',
        width: '120'
      }, {
        field: 'completeTime',
        title: '供货完成日期',
        width: '120',
        formatter: ['toDateString', 'yyyy-MM-dd']
      }, {
        field: 'businessName',
        title: '供应商名称',
        minWidth: '150'
      }, {
        field: 'storehouseName',
        title: '仓库名称',
        minWidth: '120'
      }, {
        field: 'fundName',
        title: '开单人',
        width: '120'
      }],
      selectItem: null
    }
  },
  created () {},
  mounted () {},
  methods: {
    getData () {
      let params = {
        companyId: this.$store.state.companyId,
        page: this.page,
        limit: this.limit,
        status: 5,
        orderDefineId: this.orderDefine.sourceOrderId,
        keywords: this.inputValue
      }
      if (this.orderDefine.type === 13) {
        params.isSend = 2
      }
      this.axios.post(`order/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = []
          res.data.data.list.forEach(i => {
            i.status = '单据完成'
            i.customerAddress = i.customerName + '/' + i.address
            this.tableData.push(i)
          })
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
          this.loading = false
        }
      })
    },
    searchBtn () {
      this.page = 1
      this.getData()
    },
    onSelect (row) {
      console.log(row)
      this.selectItem = row
      this.$nextTick(() => {
        this.$refs.selectReturnMaterial.selectMaterialVisible = true
        this.$refs.selectReturnMaterial.getData()
      })
    },
    onClose () {
      this.inputValue = ''
      this.tableData = []
      this.selectVisible = false
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getData()
    }
  },
  watch: {
    inputValue (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    height: 550px;
  }
  .el-form-item{
    margin-bottom: 0px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
  .content /deep/ .el-input__icon{
    color: #30313a;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/SelectReturnMaterialReceipt.vue